import { OperationType } from '~/types/OperationType';

export const staticQrOperationTypeByFeature: Record<string, OperationType> = {
  veengu_business_purchase_byStaticQr: 'PURCHASE',
  veengu_business_cashWithdrawal_byStaticQr: 'CASH_WITHDRAWAL',
};

export const getStaticQrOperationTypes = (features?: string[]): string[] =>
  Object.entries(staticQrOperationTypeByFeature)
    .filter(([feature]) => features?.includes(feature))
    .map(([, operationType]) => operationType);
